import { mdiClipboardMinusOutline } from '@mdi/js'

export default {
  title: 'Archive',
  icon: mdiClipboardMinusOutline,
  to: 'archive-teacher',
  resource: 'ArchiveTeacher',
  action: 'read',
}
